<template>
  <span class="user-utility-button">
    <v-menu offset-y transition="slide-y-transition" :close-on-content-click="false" v-model="menuActive">
      <template #activator="{ on, attrs }">
        <button v-bind="attrs" v-on="on" class="menu-button" :class="{ 'no-padding': noPadding }">
          <v-icon :size="iconSize">mdi-dots-horizontal</v-icon>
        </button>
      </template>
      <v-list class="utility-menu">
        <v-list-item @click="toggleFriendship(workId, medium)">
          <!-- TODO: Add v-icon-->
          Add Friend
          <!-- TODO: Include if friend or not-->
        </v-list-item>

        <v-list-item
          :to="{
            name: 'profile',
            params: {
              username,
            },
          }"
        >
          View Profile
        </v-list-item>

        <v-list-item @click="menuActive = false"> Close </v-list-item>
      </v-list>
    </v-menu>
  </span>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "user-utility-button",

  props: {
    iconSize: Number,
    userId: [String, Number],
    username: String,
  },

  data: function () {
    return {
      menuActive: false,
    };
  },

  methods: {
    ...mapMutations(["showSnackbar", "showReportPopup"]),
  },
};
</script>

<style>
.user-utility-button {
  line-height: 1;
}

.menu-button.no-padding {
  padding: 0;
}

.utility-menu .v-icon {
  margin-right: 16px;
}
</style>
